<template>
  
  <div>

    <div id="why" class="bg-image small"></div>

    <div class="bg-white">
      <div class="container py-3">
        <br class="d-none d-md-block">
        <h1 class="h2">About us</h1>
        <p class="lead grey">Since 1975, we have helped our clients focus on their core. With a fleet of more than 10,000 trailers, PNO is the Nordic region's leader in trailer rental.</p>
       	<hr>
      	<br>
        <div class="row text-center">
  	      <div class="col-lg-4">
            <i class="fas fa-3x fa-fw fa-hand-holding-usd green mb-5"></i>
						<h5 class="mb-1">Predictable cost</h5>
						<p class="grey mb-4 mb-lg-5 px-4">All-inclusive and a fixed monthly fee.</p>
            <br class="d-none d-xl-block">
						<h5 class="mb-1">Liquidity effective</h5>
						<p class="grey mb-4 mb-lg-5 px-4">No upfront payment.</p>
            <br class="d-none d-lg-block">
						<h5 class="mb-1">Asset light</h5>
						<p class="grey mb-4 px-4">Hassle-free return without asset sale and divestment risk.</p>
            <hr class="d-lg-none">
            <br class="d-lg-none">
  			  </div>
  	      <div class="col-lg-4">
            <i class="far fa-3x fa-fw fa-handshake yellow mb-5"></i>
						<h5 class="mb-1">Results and relationships</h5>
						<p class="grey mb-4 mb-lg-5 px-4">We believe strong relationships are the basis for good results.</p>
						<h5 class="mb-1">A-Z handling</h5>
						<p class="grey mb-4 mb-lg-5 px-4">From order to divestment and everything in between.</p>
						<h5 class="mb-1">Focus on your core business</h5>
						<p class="grey mb-4 px-4">Free up time and resources to focus on your core business.</p>
            <hr class="d-lg-none">
            <br class="d-lg-none">
  	      </div>
  	      <div class="col-lg-4">
						<i class="fas fa-3x fa-fw fa-bullseye red mb-5"></i>
						<h5 class="mb-1">One point of contact</h5>
						<p class="grey mb-4 mb-lg-5 px-4">Pick up where you left off with your dedicated contact person.</p>
						<h5 class="mb-1">Straightforward</h5>
						<p class="grey mb-4 mb-lg-5 px-4">Our approach is pragmatic and simple.</p>
            <br class="d-none d-xl-block">
						<h5 class="mb-1">One contract</h5>
						<p class="grey mb-4 px-4">You only need to sign on the dotted line one time to access all our services.</p>
  	      </div>
        </div>
      </div>
    </div>

  	<pno-prompt />

  </div>

</template>

<script>
import PnoPrompt from '@/components/PnoPrompt.vue'

export default {
    mounted() {
        this.$store.commit('meta/title', 'About us')
        this.$store.commit('meta/description', 'Since 1975, we have helped our clients focus on their core. With a fleet of more than 10,000 trailers, PNO is the Nordic regions leader in trailer rental.')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/bg_pno_default.jpg') , 'ogimage'));
    },
	components: { PnoPrompt },
}
</script>
